import React, { useContext } from 'react'

import { ArrowDownOutlined, ArrowUpOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Card, Checkbox, Typography } from 'antd'

import { COMPARE_GREEN, COMPARE_RED } from '../../../helpers/Globals';
import createAudience from './MarketingAudienceCreate';
import DiTooltip from '../../DiTooltip'

export default function MarketingAudienceCard({
  selectedAudience,
  contextValue,
  description,
  compareDate,
  onChange,
  hideEdit,
  onSave,
  amount,
  title,
  id,
}) {
  
  const checked = selectedAudience.includes(id); //se l'id del pubblico è presente in quelli selezionati, lo do per selezionato
  
  return (
    <div className='relative'>
      <Card
        bordered={false}
        className='di-audience-card text-center overflow-hidden radius-2  bg-dark-02'
      
        // titolo del pubblico e descrizione
        title={
          <div className='flex align-center justify-center gap-5 text-wrap'>
            <Checkbox
              className='flex align-center gap-5'
              onChange={()=>onChange({audienceId: id, audienceTitle:title,audienceUsers:amount})}
              checked={checked}
              value={id}
            >
              <Typography.Title
                className='m-0 mb-0'
                level={5}
              >
                {title}
              </Typography.Title>
            </Checkbox>
            {description && <DiTooltip text={description} />}
          </div>
        }  
        // titolo del pubblico e descrizione
  
        // valori e date di confronto
        actions={
          compareDate && compareDate.map((e) => {
            return (
              <div className="flex w-100 justify-center fs-15" style={{color:e.positive ? COMPARE_GREEN : COMPARE_RED}}>
                {e.positive ? <ArrowUpOutlined/> : <ArrowDownOutlined/>}
                {e.amount}
              </div>
            )
          })
        }
        // valori e date di confronto
      >
         <Typography className="mb-0 m-0 fs-20 color-primary" level={4}>{amount}</Typography>
      </Card>
  
      {!hideEdit &&
        <Button
          onClick={() => createAudience({ context: contextValue, audienceId: id, onSave:onSave })}
          className='di-edit-audience'
          icon={<EditOutlined />}
          type='primary'
          shape='circle'
          size='small'
        />
      }
      
    </div>
  )
}
